import { createContext, use } from "react";

import invariant from "tiny-invariant";

import { TradeThemeVariant } from "./types";

type TradeContextType = {
  slippage: string;
  theme: TradeThemeVariant;
};

export const TradeContext = createContext<TradeContextType>({
  theme: "spearmint",
  slippage: "1",
});

export const useTrade = () => {
  const ctx = use(TradeContext);

  invariant(ctx, "ctx must be used within TradeContext");

  return ctx;
};
